module.exports = __webpack_public_path__ + "static/media/ready-order.87636678.svg";